import { render, staticRenderFns } from "./issues_analytics.vue?vue&type=template&id=31f6cde7"
import script from "./issues_analytics.vue?vue&type=script&lang=js"
export * from "./issues_analytics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports